export enum BusinessSteps {
    details = "details",
    accounting = "accounting",
    sectionals = "sectionals",
    vatconfiguration = "vatconfiguration",
    ivaprorata = "ivaprorata"
}

export const businessStepsArr = [
    BusinessSteps.details,
    BusinessSteps.accounting,
    BusinessSteps.sectionals,
    BusinessSteps.vatconfiguration,
    BusinessSteps.ivaprorata
];
